
import * as PropTypes from 'prop-types'

import { ITranslationContext } from '../../../translations';
import { clickHandler } from '../../../utils/util';


interface CustomerPhotoViewProps {
    photographUrl: string;
    close: () => void;
}

const CustomerPhotoView = (props: CustomerPhotoViewProps, context: ITranslationContext) => {
    return <div className='reception-customer-photo-overlay'>
        <img src={props.photographUrl} />
        <div className='btn-toolbar' style={({ marginTop: '20px' })}>
            <button className='btn btn-basic' onClick={e => clickHandler(e, props.close)}>{context.t('Global:close')}</button>
        </div>
    </div>;
}

CustomerPhotoView.contextTypes = {
    t: PropTypes.func
}

export default CustomerPhotoView;